/**
 * Created by claude on 09.02.26.
 */

class GameSceneComponent extends ScriptComponent {
    onCreate() {
        const runtime = (PrefabBuilder.resolveProperty(this.options.args, this.context) || [])[0] || {};

        this.level = runtime.level;
        this.gameOptions = runtime.gameOptions || {};

        this.styling = runtime.styling || this.getBackgroundStyles();
        this.audioStyles = this.getAudioStyles();
        this.bundles = this.listBundles();
    }

    onAttach() {
        this.scene = this.node;

        const sceneComponent = ComponentMap.get(this.node, SceneComponent);
        sceneComponent.setStyling(this.styling);
        sceneComponent.setAudioStyles(this.audioStyles);
        sceneComponent.setBundles(this.bundles);
    }

    onDestroy() {
        if (Game.currentGame) {
            Game.currentGame.stop();
            Game.currentGame = undefined;
        }
    }

    onBeforeSceneLoaded() {
        cleverapps.environment.setLevel(this.level.levelNo);
        cleverapps.environment.setEpisode(this.level.episodeNo);
        cleverapps.environment.setScene(cleverapps.Environment.SCENE_GAME);

        this.level.setupContent();

        this.game = new Game(this.level, this.gameOptions);
    }

    onSceneLoaded() {
        const scene = this.scene;
        const game = this.game;
        const level = game.level;

        cleverapps.availableMove.pause("intro");

        if (levels.cookieJar && levels.cookieJar.shouldBeVisible()) {
            levels.cookieJar.setVisible();
        }

        if (game.competition && cleverapps.isKnockoutGame()) {
            this.playersView = new KnockoutPlayersView(game.competition, cleverapps.knockoutGame.rumble.getCurrentRound());
            scene.addChild(this.playersView);
        }

        if (game.scoreBar) {
            this.scoreBarView = new ScoreBarView(game.scoreBar);
            scene.addChild(this.scoreBarView, 0);
        }

        if (["riddles", "heroes"].indexOf(cleverapps.config.name) !== -1) {
            if (!level.isBonus()) {
                this.infoPanel = new InfoPanel();
                scene.addChild(this.infoPanel);
            }

            if (!level.isTricky()) {
                this.controlsPanel = new ControlsPanel();
                if (!cleverapps.restoreProgress.isAvailable()) {
                    scene.addChild(this.controlsPanel);

                    game.on("outcome", () => {
                        this.controlsPanel.hide();
                    }, scene);
                }
            }
        }

        game.on("haveOutcome", this.animateOutcome.bind(this), scene);

        cleverapps.pool.drainAllPools();
        game.initPool();

        if (level.isRegular() || level.isBonusWorldLevel()) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LEVEL_START, game.getLevelStatsParams());

            if (GameBase.levelLostHash === this.level.hash) {
                GameBase.levelLostHash = undefined;
                GameBase.levelRestartCount = (GameBase.levelRestartCount || 0) + 1;

                if ([2, 3, 5, 8, 10, 15, 20, 30, 40, 50].includes(GameBase.levelRestartCount)) {
                    connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.LEVEL_RESTART + GameBase.levelRestartCount);
                }
            }
        }

        game.on("showMessage", this.onGameMessage.bind(this), scene);

        this.exclamationView = new ExclamationView();
        scene.addChild(this.exclamationView, 30);
        this.exclamationView.setAlignment(cleverapps.styles.GameScene.exclamation);

        if (typeof FlyingAdView !== "undefined") {
            scene.addChild(new FlyingAdView());
        }

        if (scene.onStop) {
            game.on("stop", scene.onStop.bind(scene), scene);
        }
    }

    onPlayIntro(f, silent) {
        const game = this.game;

        if (cleverapps.config.debugMode) {
            SnapshotAdapters.extractData((data) => {
                game.cachedIntro = data;
            });
        }

        let actions = game.listIntroActions();

        if (silent) {
            actions = actions.map((action) => function (f) {
                action(f, silent);
            });
        }

        game.introPlaying = true;

        cleverapps.focusManager.compound(() => {
            game.introPlaying = false;
            game.cachedIntro = undefined;
            cleverapps.availableMove.resume("intro");
            f();
        }, actions);

        return true;
    }

    onCloseAction() {
        if (BackToAdminOrEditorAction.call(this) || !this.game) {
            return true;
        }

        cleverapps.focusManager.display({
            focus: "GameSceneCloseAction",
            action: (f) => {
                this.game.leave(f);
            }
        });

        return true;
    }

    onTransitionAnimationDidStart() {
        if (Game.currentGame && Game.currentGame.shouldSkipVictoryWindow()) {
            return true;
        }
    }

    animateOutcome() {
        if (cleverapps.focusManager.isFocused()) {
            return;
        }

        let tapToSkip;
        let victoryRewards;

        cleverapps.focusManager.display({
            focus: "ChangeOutcome",

            actions: [
                VictoryMessageAction,

                (f) => {
                    if (this.game.needBonusByLeftMoves()) {
                        tapToSkip = this.createTapToSkip();

                        this.game.bonusByLeftMoves(f);
                    } else {
                        f();
                    }
                },

                (f) => {
                    if (tapToSkip) {
                        tapToSkip.hide();
                    }

                    f();
                },

                (f) => {
                    this.game.stop();
                    f();
                },

                SaveFinalResultsAction,

                HideAnimations.bind(this),

                (f) => {
                    if (!cleverapps.isKnockoutGame()) {
                        cleverapps.missionManager.run();
                    }
                    f();
                },

                ReportLevelOutcomeAction.bind(this),

                (f) => {
                    if (!BackToAdminOrEditorAction.isTestPlay()) {
                        f();
                        return;
                    }

                    if (cleverapps.isKnockoutGame()) {
                        cleverapps.knockoutGame.stopRumble();
                    }

                    cleverapps.focusManager.distract({
                        focus: "BackToAdminOrEditorAction",
                        action: (f) => BackToAdminOrEditorAction.call(this, f)
                    });
                },

                (f) => {
                    victoryRewards = ShowOutcomeWindow.call(this, f);
                },

                BoatswainAction.bind(this),

                (f) => {
                    const scene = cleverapps.Scenes.GetRunningScene();

                    const sideBar = ComponentUtils.findComponentByName(scene, "SideBarController");

                    if (sideBar && cleverapps.environment.isMainScene()) {
                        cleverapps.focusManager.showControlsWhileFocused(sideBar.getControls());
                    }

                    f();
                },

                ActionPlayer.parallel([
                    (f) => {
                        cleverapps.eventBus.trigger("victoryRewardsReceive");

                        if (victoryRewards && !victoryRewards.isReceived()) {
                            victoryRewards.receiveRewards(f);
                        } else {
                            f();
                        }
                    },

                    ...cleverapps.missionManager.getRunningMissions()
                        .filter((mission) => mission.logic && mission.logic.receiveRewards)
                        .map((mission) => ((callback) => mission.logic.receiveRewards(callback)))
                ]),

                (f) => {
                    if (victoryRewards) {
                        victoryRewards.removeFromParent();
                    }

                    f();
                },

                NewHeroAction.bind(this),
                ComicsAction.bind(this),
                KnockoutVictoryAction.bind(this),
                LevelDialogueAction.bind(this),
                RateWindowAction.bind(this),
                LeaguesUpgradeAction.bind(this),
                StickersRewardAction.bind(this)
            ]
        });
    }

    getBackgroundStyles() {
        const gameSceneStyling = cleverapps.styles.GameScene.STYLING;

        let styling = gameSceneStyling.regular[Math.abs(this.level.getHumanReadableNumber()) % gameSceneStyling.regular.length];

        if (this.level.isBonusRound() || this.level.isBonus()) {
            styling = gameSceneStyling.bonus;
        } else if (this.level.isHard() || cleverapps.isRumble() && cleverapps.knockoutGame.rumble.getCurrentRound().isLast()) {
            styling = gameSceneStyling.hard;
        } else if (this.level.isTricky()) {
            styling = gameSceneStyling.tricky;
        }

        const stylingBundles = [];
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            stylingBundles.push(styling.bundle);
        } else {
            stylingBundles.push(styling.bundle.replace("_vertical", "_horizontal"));
        }
        stylingBundles.push(styling.bundle.replace("_vertical", `_${cleverapps.config.orientation}`));

        const bundle = stylingBundles.find((bundle) => bundles[bundle]);

        if (bundle) {
            return {
                ...styling,
                bundle,
                backgroundId: bundles[bundle].urls[styling.backgroundId] ? styling.backgroundId : "background",
                animation: bundles[bundle].jsons.background_spine || styling.animation
            };
        }

        return styling;
    }

    getAudioStyles() {
        return {
            res: cleverapps.skins.getSlot("gameAudio") || this.styling.music,
            fadeIn: cleverapps.styles.GameScene.sound.fadeIn,
            delay: cleverapps.styles.GameScene.sound.delay
        };
    }

    listBundles() {
        const level = this.level;
        const styling = this.styling;

        const gameBundles = ["game"];

        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            gameBundles.push("game_background_horizontal");
        } else {
            gameBundles.push("game_background_vertical");
        }

        if (styling) {
            gameBundles.push(styling.bundle);
        }

        if (level) {
            gameBundles.push(level.bundleId());
            gameBundles.push(level.getImageBundle());

            const cellSkins = level.meta.cellSkins;
            if (cellSkins) {
                Object.values(cellSkins).forEach((skin) => {
                    if (bundles[skin]) {
                        const baseSkin = skin.substring(0, skin.indexOf("_reskin"));
                        const baseInd = gameBundles.indexOf(baseSkin);
                        gameBundles.splice(baseInd, baseInd > 0 ? 1 : 0, skin);
                    }
                });
            }

            if (cleverapps.config.rpg) {
                gameBundles.push("enemies");
            }
        }

        if (["riddles", "heroes"].includes(cleverapps.config.name) && level && level.isTricky()) {
            gameBundles.push("danger_component");
        }

        if (cleverapps.config.subtype === "stacks") {
            gameBundles.push(`extra_${cleverapps.settings.language}`);
        }

        if (bundles[`letters_${cleverapps.settings.language}`]) {
            gameBundles.push(`letters_${cleverapps.settings.language}`);
        }

        return gameBundles.filter((bundle) => bundle && bundles[bundle]);
    }

    createTapToSkip() {
        const scene = this.scene;

        const tapToSkip = new TapToSkip({
            text: Messages.get("TapToSkip"),
            onSkip: () => {
                Game.currentGame.skipBonusAnimations = true;
                Game.currentGame.trigger("onSkip");
            }
        });
        tapToSkip.setAlignment(cleverapps.styles.TapToSkip);
        tapToSkip.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 2);

        tapToSkip.show();
        scene.addChild(tapToSkip);

        return tapToSkip;
    }

    onGameMessage(message) {
        const messageView = new GameMessageView(message);
        this.scene.addChild(messageView);
    }
}

Prefab.registerComponent("GameSceneComponent", GameSceneComponent);
